import { gql } from '@apollo/client'
import { buildGraphqlQuery } from '@ztechapps/common.utils'

//region documentFragment
const documentFragment = gql`
  fragment userDefaultFragment on User {
    _id
    status
    tenantId
    profile {
      _id
      name
      picture
      email
    }
    roles
    timeZone
  }
`
//endregion

export const queries = buildGraphqlQuery('User', documentFragment)

export const meQuery = gql`
  ${documentFragment}
  query me {
    me {
      ...userDefaultFragment
    }
  }
`

export const logoutQuery = gql(`
  mutation logout($accessToken: String!) {
    logout(accessToken: $accessToken) {
      accessToken
    }
  }
`)
